// @flow
let el = document.querySelector('form[data-notification-preferences]');

if (el instanceof HTMLFormElement) {
  require.ensure('../forms/notification_preferences_form', require => {
    const NotificationPreferencesForm = require('../forms/notification_preferences_form');
    new NotificationPreferencesForm(el);
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/notification_preferences_form.js